(($)=>{
    "use strict";

    $('.testimonial-privacy__slider-wrapper').slick({
        arrows: true,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        prevArrow: $('.testimonial-prev'),
        nextArrow: $('.testimonial-next'),
    });


})(jQuery);